// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__Bvuwr","disabled":"FileBtn_disabled__f-UFh","warn":"FileBtn_warn__7EVjU","fade":"FileBtn_fade__1bGQ-"};